import transform from 'lodash/transform';
import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';

function difference(object, base, ignore = []) {
	function changes(object, base) {
		return transform(object, function(result, value, key) {
			if(ignore.includes(key)) return;
			if (!isEqual(value, base[key])) {
				result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value;
			}
		});
	}
	return changes(object, base);
}

export {
    difference
};